import { ROUTE_REGISTRY_ENTRIES, type RouteSegment } from './routeRegistry'
import type { RouteKey } from '@omnea-app/fe-routing/routes/routeKeys'
import type { ParsedUrlQuery } from 'querystring'

const matchesSegment = ({ queryParam, value }: RouteSegment, query: ParsedUrlQuery): boolean => {
  const queryValue = query[queryParam]
  return (Array.isArray(queryValue) ? queryValue[0] : queryValue) === value
}

/** Returns null for an address the registry does not name, leaving what that means to the caller. */
export const resolveRouteKey = (pattern: string, query: ParsedUrlQuery): RouteKey | null => {
  const candidates = ROUTE_REGISTRY_ENTRIES.filter(([, definition]) => definition.pattern === pattern)

  for (const [key, { segment }] of candidates) {
    if (segment != null && matchesSegment(segment, query)) return key
  }

  return candidates.find(([, { segment }]) => segment == null)?.[0] ?? null
}
